function Header() {
  return (
    <header
      className="header"
      style={{ backgroundImage: "url(./images/yodogawa-16.jpg)" }}
    >
      <div className="top-set">
        <div>
          <div className="start">
            <img src="images/yodogawa-9.png" alt="10/21 10時から" />
          </div>
        </div>

        <div className="muryo">
          <img src="images/yodogawa-8.png" alt="参加費無料" />
        </div>
      </div>

      <div className="kaisuu">
        <span className="renzoku">連続講座</span>
        <span>全</span>
        <span className="maru wf-num">6</span>
        <span>回</span>
      </div>

      <h1 className="main-title wf-sawarabimincho">
        <span className="red">観光</span>
        <br />
        まちあるき
        <br />
        ガイド養成講座
      </h1>
    </header>
  );
}

export default Header;
